<y42-data-test-builder *ngIf="state.sidebarOpened"></y42-data-test-builder>
<div class="mr-6" *ngIf="!state.sidebarOpened">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
